<template>
  <div class="zj-actionpanel">
    <span style="vertical-align: middle; font-size: 1.3333rem">
      {{ dateTime + "\u3000" }}{{ weather }}
    </span>

    <el-dropdown
      class="user-actions"
      trigger="click"
      @command="doCmd"
      style="margin: 0 1.0833rem 0 2rem"
    >
      <span class="el-dropdown-link">
        <el-avatar
          shape="square"
          size="small"
          :src="avatarUrl"
          :title="user.DisplayName"
          style="cursor: pointer"
        ></el-avatar>
        <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
      </span>
      <el-dropdown-menu
        class="zj-actionpanel-dropdown-user-actions"
        slot="dropdown"
      >
        <el-dropdown-item icon="el-icon-plus" command="userInfo"
          >用户信息</el-dropdown-item
        >
        <el-dropdown-item icon="el-icon-plus" command="passwd"
          >密码设置</el-dropdown-item
        >
        <el-dropdown-item icon="el-icon-plus" command="platform"
          >关于平台</el-dropdown-item
        >
        <el-dropdown-item icon="el-icon-plus" command="logout"
          >退出登录</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>

    <el-badge v-if="!isOnlyEmergency" is-dot class="item">
      <div @click="showWarnMessage()" style="cursor: pointer"></div>
    </el-badge>

    <el-dialog
      title="用户信息"
      :visible.sync="dialogUser"
      width="50%"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
    >
      <el-form
        ref="userInfoForm"
        v-if="userInfoObj"
        label-width="100px"
        style="width: 90%"
      >
        <!-- <el-form-item label="用户logo" style="height: 60px">
        <img src="../assets/configlogo.png" />
      </el-form-item> -->
        <el-form-item label="账号">
          <el-input v-model="userInfoObj.LoginName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="userInfoObj.phonenumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="userInfoObj.email" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户姓名">
          <el-input v-model="userInfoObj.nickName" disabled></el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-input v-model="userInfoObj.dept.deptName" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <div class="zj-actionpanel-dialog-password">
      <el-dialog
        title="修改密码"
        :visible.sync="dialogPwd"
        width="35%"
        :append-to-body="true"
        style="text-align: left"
        :destroy-on-close="true"
      >
        <ZjChangePasswd
          @clickCancel="dialogPwdCancel"
          @changeSuccess="dialogPwdOk"
        ></ZjChangePasswd>
      </el-dialog>
    </div>
    <el-dialog
      title="关于平台"
      :visible.sync="dialogPlatform"
      width="50%"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
    >
      <el-form
        ref="userForm"
        v-if="platformData"
        label-width="100px"
        style="width: 90%"
      >
        <!-- <el-form-item label="用户logo" style="height: 60px">
          <img src="../assets/configlogo.png" />
        </el-form-item> -->
        <el-form-item label="系统名称">
          <el-input v-model="platformData[0]" disabled></el-input>
        </el-form-item>
        <el-form-item label="版本号">
          <el-input v-model="platformData[1]" disabled></el-input>
        </el-form-item>
        <el-form-item label="版权声明">
          <el-input v-model="platformData[2]" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品声明">
          <el-input
            v-model="platformData[3]"
            type="textarea"
            :rows="5"
            disabled
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <div class="zj-actionpanel-dialog-alert">
      <WarnList
        :showList="showList"
        :list="warnMessageList"
        @closeDialog="closeWarnMessage"
      ></WarnList>
      <WarnPopUp
        :showPopUp="showPopUp"
        :form="popUpData"
        @closePopUp="closeWarnPopUp"
      ></WarnPopUp>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import ZJApis from "../api";
import ZjChangePasswd from "./ChangePassword.vue";
import WarnList from "./WarnList.vue";
import WarnPopUp from "./WarnPopUp.vue";
import { listWarnRecord } from "@/api/src/warnMessage";
import { getLogOut } from "@/api/system/permission/login";
import { getToken } from "@/utils/auth";
import { getWeatherByCity } from "@/api/src/equipmentDataStat";

export default {
  name: "ZjActionPanel",
  props: {
    height: String,
  },
  dicts: ["integrated_system_config"],
  components: {
    ZjChangePasswd,
    WarnList,
    WarnPopUp,
  },
  data() {
    return {
      // 定时器
      timer: null,
      // 基础信息---日期时间
      dateTime: moment().format("MM月DD日 HH:mm:ss"),
      // 基础信息---天气
      weather: "",
      //用户信息
      dialogUser: false,
      // 密码修改弹框
      dialogPwd: false,
      // 关于平台弹框
      dialogPlatform: false,
      // 是否显示报警消息列表
      showList: false,
      // 报警消息条数
      warnMessageCount: 0,
      // 报警消息列表
      warnMessageList: null,
      // 是否显示报警弹框
      showPopUp: false,
      // 报警弹框数据
      popUpData: {
        thirdSystemCode: "",
      },
      // 平台参数
      platformData: ["", "", "", ""],
      userInfoObj: null,
      wsUrl:
        global.$config.api.webSocketUrl + "/websocket/warn?token=" + getToken(), //ws地址
      websocket: null, //ws实例
      lockReconnect: false, //避免重复连接
      timeout: 30 * 1000, //30秒一次心跳
      timerObj: null, //心跳倒计时
      serverTimerObj: null, //心跳倒计时
      timerNum: null, //断开 重连倒计时，
      cityName: Array.isArray(global.$config.app.weatherCityName)
        ? (typeof global.$config.app.weatherCityName[0] === 'string' ? global.$config.app.weatherCityName[0] : global.$config.app.weatherCityName[0].value)
        : global.$config.app.weatherCityName,

      isOnlyEmergency: global.$config.app.isOnlyEmergency || false,
    };
  },
  computed: {
    avatarUrl() {
      const loc = window.location;
      const defaultUrl = loc.protocol + "//" + loc.host + "/img/touxiang.png";
      return this.THM("header.avatarUrl", defaultUrl);
    },
  },
  created() {
    if (!this.isOnlyEmergency) {
      this.getWarnMessage();
      this.initWebSocket();
      this.getWeather();
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.dateTime = moment().format("MM月DD日 HH:mm:ss");
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getWeather() {
      // let searchInfo = {
      //   City: "周口市",
      //   Source: "",
      // };
      // new ZJApis.WeatherApi()
      //   .GetWeather(searchInfo)
      //   .then((r) => {
      //     let arr = r.data.Data.day7;
      //     let now = arr.find((item) => {
      //       return item.time == moment().format("YYYY-MM-DD");
      //     });
      //     this.weather =
      //       now.weather + "\u3000" + now.temp0 + "~" + now.temp1 + "℃";
      //   })
      //   .catch((e) => {
      //     this.$message({
      //       type: "error",
      //       message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
      //     });
      //   });
      getWeatherByCity({ city: this.cityName }).then((res) => {
        console.log("天气", res);
        if (res && res.data && res.data.data) {
          let inner = res.data.data;
          let now = inner.forecast[0];
          if (now) {
            this.weather = now.type + "　" + inner.wendu + "℃";
          }
          // inner.forecast.forEach(function (item) {
          //   item.dateName = that.getDateName(item.time);
          //   item.monthAndDay = that.getMonthAndDay(item.time);
          // });
          // this.d = data;
          // this.handleTabChange(0);
        }
      });
    },
    doCmd(action) {
      switch (action) {
        case "userInfo":
          this.userInfo();
          break;
        case "passwd":
          this.passwd();
          break;
        case "platform":
          this.platform();
          break;
        case "logout":
          this.logout();
          break;
      }
    },
    //用户信息
    userInfo() {
      this.userInfoObj = this.$user || this.user;
      if (this.userInfoObj.dept == null || this.userInfoObj.dept == undefined) {
        this.userInfoObj.dept = {
          deptName: "",
        };
      }
      this.dialogUser = true;
      console.log(this.$user);
    },
    //修改密码
    passwd() {
      this.dialogPwd = true;
    },
    // 关于平台
    platform() {
      this.$nextTick(() => {
        this.getDicts("integrated_system_config").then((res) => {
          this.platformData = res.rows.map((item) => {
            return item.dictName;
          });
        });
      });
      this.dialogPlatform = true;
    },
    // 退出登录
    logout() {
      this.logInfo.ActionName = "注销";
      this.logInfo.LogMessage = "注销成功";
      this.logInfo.ModuleName = "登录";
      this.logInfo.PageName = "登出";
      this.addOperationLog();
      getLogOut();
      if (window.opener) {
        this.user.logout();
        window.location.href = "about:blank";
        window.close();
      } else {
        // getLogOut().then((res) => {
        //   if (res.code == 200 && res.message == "success") {
        //     this.$message({ type: "success", message: res.data });
        location.href = "/";
        window.ZJApp.ZJUser.prototype.logout();
        // this.user.logout();
        // this.$zjapp.emit("logout");
        //   }
        // });
      }
      // if (localStorage.getItem("isIgnoreLogin") == "false") {
      //   this.user.logout();
      //   this.$zjapp.emit("logout");
      //   this.$router.replace({ path: this.BASE_URL });
      // } else {
      //   var userAgent = navigator.userAgent;
      //   if (
      //     userAgent.indexOf("Firefox") != -1 ||
      //     userAgent.indexOf("Chrome") != -1
      //   ) {
      //     window.location.href = "about:blank";
      //     window.close();
      //   } else {
      //     window.opener = null;
      //     window.open("", "_self");
      //     window.close();
      //   }
      // }
    },
    dialogPwdCancel() {
      this.dialogPwd = false;
    },
    dialogPwdOk() {
      this.dialogPwd = false;
      this.logout();
    },
    // 弹出报警消息
    showWarnMessage() {
      this.getWarnMessage();
      this.showList = true;
    },
    // 关闭报警消息
    closeWarnMessage() {
      this.showList = false;
    },
    // 获取报警消息
    getWarnMessage() {
      listWarnRecord({ warnStatus: 1 }).then((response) => {
        //未处理的报警消息
        this.warnMessageList = response.rows.map((item) => {
          return {
            id: item.id,
            startTs: moment(item.startTs).format("YYYY-MM-DD HH:mm:ss"),
            warnName: item.warnName,
          };
        });
        this.warnMessageCount = response.total;
      });
    },
    // 时间戳转xxxx-xx-xx
    getDate(time) {
      let tempTime = new Date(time);
      let year = tempTime.getFullYear();
      let month = tempTime.getMonth() + 1;
      let day = tempTime.getDate();
      let hour = tempTime.getHours();
      let min = tempTime.getMinutes();
      let sec = tempTime.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    // 关闭报警弹框
    closeWarnPopUp() {
      this.showPopUp = false;
    },
    // 初始化websocket
    initWebSocket() {
      if (typeof WebSocket == "undefined")
        return console.log("您的浏览器不支持websocket");
      this.websocket = new WebSocket(this.wsUrl); //创建实例对象
      this.websocket.onopen = this.websocketOnOpen;
      this.websocket.onmessage = this.websocketOnMessage;
      this.websocket.onerror = this.websocketOnError;
      this.websocket.onclose = this.websocketOnClose;
    },
    // 连接建立触发
    websocketOnOpen(e) {
      // 连接建立之后执行send方法发送数据
      this.websocket.send(e);
    },
    // 收到服务器消息时触发
    websocketOnMessage(e) {
      let res = JSON.parse(e.data);
      let { code, data } = res;
      if (code == 200 && data instanceof Object) {
        data.startTs = moment(data.startTs).format("YYYY-MM-DD HH:mm:ss");
        this.popUpData = data;
        this.showPopUp = true;
      }
      // 收到消息，重置心跳
      this.reset();
    },
    // 重置心跳
    reset() {
      clearTimeout(this.timerObj); //关闭延时器
      clearTimeout(this.serverTimerObj); //关闭延时器
      this.start();
    },
    // 开启心跳
    start() {
      let self = this;
      self.timerObj && clearTimeout(self.timerObj);
      self.serverTimerObj && clearTimeout(self.serverTimerObj);
      self.timerObj = setTimeout(function() {
        if (self.websocket.readyState == 1) {
          //如果连接正常
          self.websocket.send("heartCheck");
        } else {
          //否则重连
          self.reconnect();
        }
        self.serverTimerObj = setTimeout(function() {
          self.websocket.close(); //超时关闭
        }, self.timeout);
      }, self.timeout);
    },
    // 重新连接
    reconnect() {
      if (this.lockReconnect) return;
      this.lockReconnect = true;
      this.timerNum && clearTimeout(this.timerNum);
      var self = this;
      this.timerNum = setTimeout(function() {
        //没连接上会一直重连，设置延迟避免请求过多
        self.initWebSocket();
        self.lockReconnect = false;
      }, 5000);
    },
    // 异常触发
    websocketOnError(e) {
      this.reconnect();
    },
    // 关闭连接触发
    websocketOnClose(e) {
      this.reconnect();
    },
  },
  destroyed() {
    //页面销毁时关闭长连接
    this.websocket.close();
  },
};
</script>
<style scoped>
.el-badge {
  margin-top: 0.5rem;
}
.el-badge > div {
  background-image: url("../assets/warnMes.png");
  background-size: 100%;
  width: 1.5833rem;
  height: 1.25rem;
}
::v-deep .el-badge__content.is-fixed.is-dot {
  background-color: #e8be2b !important;
  width: 0.75rem;
  height: 0.75rem;
}
</style>
